import { silentLogger } from "@buildwithflux/shared";
import { create } from "mutative";
import { PcbLayoutRuntimeRulesManager, PcbNodeBaker, PcbTreeManager } from "../layout_engine";
/**
 * The purpose of this function to is to answer the question: IF we were to add this node given the current state
 * of the layout engine, what would the resulting bakedRules look like for that node?
 *
 * @returns a copy of the 'newNode' with bakedRules included
 */
export function createBakedPseudoNode(newNode, documentState, pcbLayoutNodes, options) {
    let pcbLayoutNodesWithNewNode;
    if (options?.dangerouslyMutateInPlace) {
        pcbLayoutNodes[newNode.uid] = newNode;
        pcbLayoutNodesWithNewNode = pcbLayoutNodes;
    }
    else {
        pcbLayoutNodesWithNewNode = create(pcbLayoutNodes, (draft) => {
            draft[newNode.uid] = newNode;
        });
    }
    const pcbNodeBaker = new PcbNodeBaker(documentState, documentState.pcbLayoutRuleSets, new PcbLayoutRuntimeRulesManager(), new PcbTreeManager(pcbLayoutNodesWithNewNode, silentLogger, options?.dangerouslyMutateInPlace), silentLogger);
    // TODO: it'd be cool if we had an API to the baking engine, that allowed us to query a baked rule value(s) for a node, without
    // the need for creating/passing a pseudo node to the baking service
    const { flattenedRules, bakedRules } = pcbNodeBaker.bakeNode(newNode);
    const bakedNode = {
        ...newNode,
        bakedRules,
        flattenedRules,
    };
    // Question: why do we need to set childUids to an empty array?
    bakedNode.childUids = [];
    // Cleanup, if required
    if (options?.dangerouslyMutateInPlace) {
        delete pcbLayoutNodes[newNode.uid];
    }
    return bakedNode;
}
//# sourceMappingURL=createBakedPseudoNode.js.map